/**
 * ACF 6.0 block - js entrypoint
 *
 * entry point for webpack, can import js scripts and create css files for block
 * @package hum-fse-6-blocks
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFlip, EffectFade } from 'swiper/modules';

// Swiper css and module styles
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-fade';

import "./scss/_slider.scss";

document.addEventListener("DOMContentLoaded", function() {

  // init Swiper
  const swiper = new Swiper('.swiper', {
    modules: [ Navigation, Pagination, Autoplay, EffectFlip, EffectFade ],
    direction: 'horizontal',
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 4000,
    },
    speed: 400,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

} );